import { useCallback, useEffect, useState } from 'react';
const useRandomPassword = () => {
    const [password, setPassword] = useState('');
    const generateRandomPassword = useCallback(() => {
        let password = '';
        const numbers = '0123456789';
        const letters = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789';
        const chars = letters.concat(numbers);
        for (let i = 0; i < config.passwordLength; i++) {
            password += chars[Math.floor(Math.random() * chars.length)];
        }
        if (!password.match(/\d/)) {
            const positions = Array.from({ length: config.passwordLength }, (_, i) => i);
            const randomPosition = positions[Math.floor(Math.random() * positions.length)];
            const passwordChars = password.split('');
            passwordChars[randomPosition] = numbers[Math.floor(Math.random() * numbers.length)];
            password = passwordChars.join('');
        }
        setPassword(password);
    }, []);
    useEffect(() => {
        generateRandomPassword();
    }, []);
    return {
        password,
        generateRandomPassword,
    };
};
export default useRandomPassword;
